'use client'

import Link from 'next/link'
import { useTranslation } from '@/lib/i18n'
import { useKnowledgeAssistant } from '@/lib/knowledge/portal-api'
import { LIBRARY_HREF } from './ask-panel'

/**
 * The portal header's link to /portal/library. Shown only once the API says the
 * knowledge module is on for the company (GET /assistant answered); the library
 * works with both assistants switched off, so their switches do not matter here.
 */
export function KnowledgeLibraryLink({ className }: { className?: string }) {
  const { t, locale } = useTranslation()
  const { moduleAvailable } = useKnowledgeAssistant(locale)
  if (!moduleAvailable) return null
  return (
    <Link href={LIBRARY_HREF} className={className}>
      {t('knowledgePortal.library.title')}
    </Link>
  )
}
